import moment from 'moment';
import {DATE_FORMAT} from '../../components/helpers/DateHelper';

export default (state, filterValues, stateKey = 'analytics') => {
    let analytics = state[stateKey].data.slice();

    if(!filterValues || filterValues.groupBy !== 'day') {
        return analytics;
    }

    let {
        startDate,
        endDate,
    } = filterValues;

    return populate(analytics, createArrayOfTimestamps(startDate, endDate));
}

/**
 * @param startTimestamp
 * @param endTimestamp          Inclusive end timestamp
 * @param target                [day, month]
 */
const createArrayOfTimestamps = (startTimestamp, endTimestamp, target = 'day') => {
    let current = moment.utc(startTimestamp * 1000).startOf(target).unix();
    let result  = [];

    endTimestamp = moment.utc(endTimestamp * 1000).endOf(target).unix();

    while(current < endTimestamp) {
        result.push(current);
        current = moment.utc(current * 1000).add(1, target + 's').unix();
    }

    return result;
};

const populate = (statistics, arrayOfTimestamps) => {
    let populatedRowsLeft = statistics.length;

    const populated = arrayOfTimestamps.map(timestamp => {
        const date = moment.utc(timestamp * 1000).format(DATE_FORMAT);
        const match = statistics.filter(item => item.key === moment.utc(timestamp * 1000).format(DATE_FORMAT));

        if (match.length) {
            --populatedRowsLeft;
        }

        return match.length ? match[0] : {key: date, value: 0};
    });

    //@TODO Fix timezones then uncomment
    // if (populatedRowsLeft > 0) {
    //     throw Error('Some of statistics coming from server was not added to result when sorting by days.');
    // }

    return populated;
};


// WEBPACK FOOTER //
// ./web/src/reducers/analytics/statisticsSelector.js